import { post } from '../../queries';
import { queryKeys } from '../../queries/queryKeys';
import { useApiMutation } from '../../queries/useApiMutation';

export const useChangePasswordMutation = () => {
    const mutation = useApiMutation<{ newPassword: string }>({
        invalidateQueryOnMutate: true,
        queryKey: queryKeys.auth(),
        mutationFn: ({ newPassword }) => post(`identity/changePassword`, { newPassword: newPassword }),
    });

    return { ...mutation };
};
